import axios from 'axios';
import { Auth } from 'aws-amplify';
import { EXPIRED } from '../auth/actions';

import Config from '../../config';

import { PROJECT_GET } from './actions';

axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';

const api_get_project = (data) => {
    return (dispatch, getState) => {

        return Auth.currentSession().then((session) => {

            const token = session && session.idToken.jwtToken;

            var config = { headers: { Authorization: 'Bearer ' + token } };

            return axios.get(`${Config.API_BASE_URL}/client-project/${data.projectId}`, config)
                .then(response => {
                    dispatch({
                        type: PROJECT_GET,
                        payload: {
                            ...response.data,
                            errors: {},
                            task: {
                                result: true
                            }
                        }
                    })

                    return true;
                })
                .catch(error => {
                    dispatch({
                        type: PROJECT_GET,
                        payload: {
                            errors: {},
                            task: {
                                result: false
                            }
                        }
                    })

                    return false;
                });
        }).catch(error => {
            dispatch({ type: EXPIRED });
        });
    };
}

export default api_get_project;